__turbopack_context__.v({
  "copiedToast": "CopyCouponButton-module__0930pW__copiedToast",
  "copyBtn": "CopyCouponButton-module__0930pW__copyBtn",
  "copyBtnCopied": "CopyCouponButton-module__0930pW__copyBtnCopied",
  "copyToastIn": "CopyCouponButton-module__0930pW__copyToastIn",
  "root": "CopyCouponButton-module__0930pW__root",
});
